import React, { useState, useEffect } from 'react';
import { Card, Typography, Container, Stepper, Step, StepLabel, Box, TextField, AppBar, Toolbar, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AgreementLab from '../reqLab/AgreementLab';
import SelectAd from '../reqLab/SelectAd';
import SelectRepoPkg from '../reqLab/appStore/SelectAppStore';
import LabName from '../reqLab/LabName';
import LabDescription from '../reqLab/LabDescription';
import ReqLabConfirm from '../reqLab/ReqLabConfirm';
import SelectAllocationMode from '../reqExamLab/SelectAllocationMode';
import Summary from '../reqLab/Summary';
import SelectExpDate from '../reqLab/SelectExpDate';
import NavigationButtons from '../reqLab/NavigationButtons';
import StudentList from '../pubLab/StudentList';
import MultipleStepBaseImage from '../reqLab/MultipleStepBaseImage';
import ExamMultipleStepBaseImage from '../reqExamLab/MultipleStepBaseImage';
import SelectProvisioningType from '../reqLab/SelectProvisioningType';
import SelectSize from '../reqLab/SelectSize';



function LabConsolleClonePage(props) {
    // Forza labVersion a 2 per la clonazione
    const forcedLabVersion = 2;

    // In clonazione, forza sempre registrationStatus a "queued"
    const ensureRegistrationStatus = (users) =>
        (users || []).map(u => ({
            ...u,
            registrationStatus: "queued"
        }));
    const initialExpirationDate = new Date(new Date().setMonth(new Date().getMonth() + 18));

    // Determina il tipo di lab
    const isExam = props.labProps?.labType === "exam";
    // In clonazione, mostra sempre lo step immagine base per permettere la scelta dell'infrastruttura
    const skipImageStep = false;


    const [repoPkgBundleSel, setRepoPkgBundleSel] = useState([]);
    const [repoPkgSel, setRepoPkgSel] = useState([]);
    const [installedPackages] = useState([]);
    const [statusRequest, setStatusRequest] = useState();
    const [isLoading, setIsLoading] = useState(0);
    const [activeStep, setActiveStep] = useState(0);
    const [physicalLabs, setPhysicalLabs] = useState([]);
    const [isSubmitted, setIsSubmitted] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [stepsData, setStepsData] = useState({});
    const [expirationMonthDuration, setExpirationMonthDuration] = useState('18');
    const [expirationDate, setExpirationDate] = useState(initialExpirationDate);
    const [isAgreementCompleted, setAgreementCompleted] = useState(false);
    const [adSel, setAdSel] = useState({});
    const [coperEasy, setCoperEasy] = useState([]);
    const [coperTeacher, setCoperTeacher] = useState([]);
    // Inizializza students e teachers con i valori del lab sorgente per la clonazione
    const [students, setStudents] = useState(ensureRegistrationStatus(props.labProps?.students));
    const [teachers, setTeachers] = useState(ensureRegistrationStatus(props.labProps?.teachers));
    const [isLabNameCompleted, setLabNameCompleted] = useState(false);
    const [labName, setLabName] = useState("");
    const [isLabnameChecked, setIsLabnameChecked] = useState(true);
    const [isLabdescriptionSpellChecked, setIsLabdescriptionSpellChecked] = useState(true);
    const [labDescription, setLabDescription] = useState("");
    const [labNotes, setLabNotes] = useState();
    const [baseImage, setBaseImage] = useState({});
    const [isBookable, setIsBookable] = useState(false);
    const [isMultipleBaseStepCompleted, setMultipleBaseStepCompleted] = useState(false);
    const [repoPkgBundleSelString, setRepoPkgBundleSelString] = useState("");
    const [provisioningType, setProvisioningType] = useState("FLOATING");
    const [useStandardCluster, setUseStandardCluster] = useState(props.labProps?.clusterType === 'standard');

    // Sincronizza students e teachers quando labProps cambia (per gestire caricamento asincrono)
    useEffect(() => {
        if (props.labProps?.students && props.labProps.students.length > 0) {
            setStudents(ensureRegistrationStatus(props.labProps.students));
        }
        if (props.labProps?.teachers && props.labProps.teachers.length > 0) {
            setTeachers(ensureRegistrationStatus(props.labProps.teachers));
        }
    }, [props.labProps?.students, props.labProps?.teachers]);

    // Steps per exam: include sempre "Immagine base" per scegliere l'infrastruttura di destinazione
    const stepsExam = [
        'Immagine base',
        'Pacchetti aggiuntivi',
        'Durata laboratorio',
        'Dimensionamento macchine',
        'Attività didattica',
        'Nome Laboratorio',
        'Descrizonione Laboratorio',
        'Note aggiuntive',
        'Allocazione postazioni esame',
        'Agreement',
        'Conferma'
    ];

    // Steps per standard (lezione): include sempre "Immagine base" in clonazione
    const stepsStandard = [
        'Immagine base',
        'Pacchetti aggiuntivi',
        'Durata laboratorio',
        'Dimensionamento macchine',
        'Attività didattica',
        'Nome Laboratorio',
        'Descrizonione Laboratorio',
        'Note aggiuntive',
        'Modifica Docenti e Studenti',
        'Agreement',
        'Conferma'
    ];

    // Offset per gli step: se si salta lo step immagine, gli step logici partono da 1
    const stepOffset = skipImageStep ? 1 : 0;

    const {
        labProps,
        isAdmin,
    } = props;

    const formatDate = (isoDate) => {
        const date = new Date(isoDate);
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return date.toLocaleDateString('it-IT', options);
    };


    const handleAgreementCompletion = (isAccepted) => {
        setAgreementCompleted(isAccepted);
    };

    const handleLabNameCompletion = (nameOk) => {
        setLabNameCompleted(nameOk);
    };

    const labNotesHandler = (event) => {
        setLabNotes(event.target.value);
    }

    const handleExpDateChange = (newExpDate) => {
        const monthDurations = {
            '3': 3,
            '6': 6,
            '12': 12,
            '18': 18
        };

        // Calcola la nuova data di scadenza in base alla scelta:
        // - Date                    -> data personalizzata scelta dal calendario
        // - '3d'                    -> 3 giorni (uso interno)
        // - '3' / '6' / '12' / '18' -> durata in mesi (default 18)
        let calculatedExpirationDate;
        if (newExpDate instanceof Date) {
            calculatedExpirationDate = newExpDate;
            setExpirationMonthDuration('custom');
        } else if (newExpDate === '3d') {
            const futureDate = new Date();
            futureDate.setDate(futureDate.getDate() + 3);
            calculatedExpirationDate = futureDate;
            setExpirationMonthDuration(newExpDate);
        } else {
            const futureDate = new Date();
            futureDate.setMonth(futureDate.getMonth() + (monthDurations[newExpDate] || 18));
            calculatedExpirationDate = futureDate;
            setExpirationMonthDuration(newExpDate);
        }

        setExpirationDate(calculatedExpirationDate.toISOString());
    };


    // Funzione helper per ottenere la baseImage corretta (selezionata o dal lab sorgente)
    const getEffectiveBaseImage = () => {
        if (skipImageStep) {
            // Step immagine saltato (lezione v2): usa i dati esistenti dal labProps
            return {
                imageOs: labProps.baseImage.os,
                imageName: labProps.baseImage.name,
                imageDes: labProps.baseImage.des,
                imageSize: labProps.baseImage.size,
                feed: labProps.baseImage.feed,
                feedBundle: labProps.baseImage.feedBundle,
                imageType: labProps.baseImage.imageType,
                destination: labProps.baseImage.destination,
            };
        }
        // Usa la baseImage selezionata dall'utente (v1 oppure exam)
        return baseImage;
    };

    const handleNext = () => {
        // get the data of the current step
        // logicalStep tiene conto dell'offset per lab v2 (senza step immagine)
        const logicalStep = activeStep + stepOffset;
        let currentStepData;
        switch (logicalStep) {
            // selezione immagine base (solo per lab v1)
            case 0:
                currentStepData = (
                    <Typography>
                        Immagine Selezionata: <Typography component="span" fontWeight="bold">{baseImage.imageName} {baseImage.imageDes}</Typography>
                        <br />
                        Pacchetti presenti nel bundle: <Typography component="span" fontWeight="bold">{repoPkgBundleSelString}</Typography>
                    </Typography>
                );
                break;
            // selezione pacchetti
            case 1:
                let repoPkgSelString;
                if (repoPkgSel.length === 0) {
                    repoPkgSelString = "Nessun pacchetto addizionale";
                } else {
                    repoPkgSelString = repoPkgSel.map(item => item.value).join(', ');
                }

                currentStepData = (
                    <Typography>
                        Pacchetti aggiuntivi selezionati: <Typography component="span" fontWeight="bold">{repoPkgSelString}</Typography>
                    </Typography>
                );
                break;
            // selezione data di scadenza
            case 2:
                currentStepData = (
                    <Typography>
                        Data di scadenza: <Typography component="span" fontWeight="bold">{formatDate(expirationDate)}</Typography>
                    </Typography>
                );
                break;
            // dimensionamento macchine
            case 3:
                currentStepData = (
                    <Box>
                        <Typography>
                            Selezione dimensionamento: <Typography component="span" fontWeight="bold">{baseImage.imageSize || getEffectiveBaseImage().imageSize}</Typography>
                        </Typography>
                        <Typography>
                            Opzione provisioning: <Typography component="span" fontWeight="bold">{provisioningType}</Typography>
                        </Typography>
                    </Box>
                );
                break;
            // attività didattica
            case 4:
                if (Object.keys(adSel).length === 0) {
                    currentStepData = (
                        <Typography>
                            Attività didattica: <Typography component="span" fontWeight="bold">Nessuna attività didattica selezionata</Typography>
                        </Typography>
                    );
                } else {
                    currentStepData = (
                        <Typography>
                            Attività didattica: <Typography component="span" fontWeight="bold">[{adSel.anaAfCod}-{adSel.anaModCod}] {adSel.anaAfDescIta}</Typography>
                        </Typography>
                    );
                }
                break;
            // nome laboratorio
            case 5:
                currentStepData = (
                    <Typography>
                        Nome laboratorio: <Typography component="span" fontWeight="bold">{labName}</Typography>
                    </Typography>
                );
                break;
            // descrizione laboratorio
            case 6:
                currentStepData = (
                    <Typography>
                        Descrizione laboratorio: <Typography component="span" fontWeight="bold">{labDescription}</Typography>
                    </Typography>
                );
                break;
            // note aggiuntive
            case 7:
                currentStepData = (
                    <Typography>
                        Note aggiuntive: <Typography component="span" fontWeight="bold">{labNotes}</Typography>
                    </Typography>
                );
                break;
            // selezione lista studenti da escludere (standard) o allocazione postazioni esame (exam)
            case 8:
                currentStepData = (
                    labProps.labType === "exam" ? (
                        <Typography>
                            Allocazione postazioni esame: <Typography component="span" fontWeight="bold">{physicalLabs.join(', ')}</Typography>
                        </Typography>
                    ) : (
                        <>
                            <Typography>
                                Elenco studenti iscritti aggiornato: <Typography component="span" fontWeight="bold">{students.filter(student => student.registrationStatus === 'queued' || student.registrationStatus === 'registered').map(student => student.email).join(', ')}</Typography>
                            </Typography>
                            <Typography>
                                Elenco docenti aggiornato: <Typography component="span" fontWeight="bold">{teachers.filter(teacher => teacher.registrationStatus === 'queued' || teacher.registrationStatus === 'registered').map(teacher => teacher.email).join(', ')}</Typography>
                            </Typography>
                        </>

                    )
                );
                break;
            // agreement
            case 9:
                currentStepData = (
                    <Typography>
                        Nota sulla mancata persistenza accettata
                    </Typography>
                );
                break;
            default:
                break;
        }


        // update stepsData with the data of the current step
        setStepsData(prevStepsData => ({
            ...prevStepsData,
            [`Step ${activeStep + 1}`]: currentStepData,
        }));

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        // logicalStep tiene conto dell'offset per lab v2 (senza step immagine)
        const logicalStep = activeStep + stepOffset;
        switch (logicalStep) {
            //
            case 0:
                break;
            // selezione immagine base (torno indietro da pacchetti)
            case 1:
                if (!skipImageStep) {
                    setMultipleBaseStepCompleted(false);
                }
                break;
            case 2:
                break;
            // dimensionamento macchine
            case 3:
                break;
            case 4:
                break;
            case 5:
                setAdSel({});
                break;
            case 6:
                break;
            case 7:
                break;
            case 8:
                break;
            case 9:
                setAgreementCompleted(false);
                break;
            case 10:
                setAgreementCompleted(false);
                break;
            default:
                break;
        }

        // Cancella i dati dello step corrente
        setStepsData((prevStepsData) => {
            const newStepsData = { ...prevStepsData };
            delete newStepsData[`Step ${activeStep}`];
            return newStepsData;
        });

        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };


    const usageType = () => {
        const stepsToUse = labProps.labType === "exam" ? stepsExam : stepsStandard;
        // logicalStep tiene conto dell'offset per lab v2 (senza step immagine)
        const logicalStep = activeStep + stepOffset;
        // Per SelectRepoPkg, usa la baseImage corretta
        const effectiveBaseImage = getEffectiveBaseImage();

        return (
            <React.Fragment>
                <form onSubmit={onSubmit}>

                    <Container>
                        <Summary stepsData={stepsData} />
                        <Stepper activeStep={activeStep} alternativeLabel>
                            {stepsToUse.map((label) => (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                        {/* Step 0: Immagine base (sempre per exam, solo per v1 nelle lezioni) */}
                        {!skipImageStep && logicalStep === 0 && (
                            <Box style={{ width: "100%", marginTop: "50px" }}>
                                <NavigationButtons ldisabled={true} rdisabled={!isMultipleBaseStepCompleted} handleBack={handleBack}
                                    handleNext={handleNext} />
                                {isExam ? (
                                    <ExamMultipleStepBaseImage
                                        setBaseImage={setBaseImage}
                                        baseImage={baseImage}
                                        setIsBookable={setIsBookable}
                                        isBookable={isBookable}
                                        setRepoPkgBundleSelString={setRepoPkgBundleSelString}
                                        setMultipleBaseStepCompleted={setMultipleBaseStepCompleted}
                                        setUseStandardCluster={setUseStandardCluster}
                                    />
                                ) : (
                                    <MultipleStepBaseImage
                                        setBaseImage={setBaseImage}
                                        baseImage={baseImage}
                                        setIsBookable={setIsBookable}
                                        isBookable={isBookable}
                                        setRepoPkgBundleSelString={setRepoPkgBundleSelString}
                                        setMultipleBaseStepCompleted={setMultipleBaseStepCompleted}
                                        labVersion={forcedLabVersion}
                                    />
                                )}
                                <NavigationButtons ldisabled={true} rdisabled={!isMultipleBaseStepCompleted} handleBack={handleBack}
                                    handleNext={handleNext} />
                            </Box>
                        )}
                        {/* Step 1: Pacchetti aggiuntivi */}
                        {logicalStep === 1 && (
                            <Box style={{ width: "100%", marginTop: "50px" }}>
                                <NavigationButtons ldisabled={skipImageStep} rdisabled={false} handleBack={handleBack}
                                    handleNext={handleNext} />
                                <SelectRepoPkg
                                    apiAuthResponse={props.apiAuthResponse}
                                    apiAuthName={props.apiAuthName}
                                    apiAuthSurname={props.apiAuthSurname}
                                    apiAuthGroups={props.apiAuthGroups}
                                    setRepoPkgSel={setRepoPkgSel}
                                    setRepoPkgBundleSel={setRepoPkgBundleSel}
                                    installedPackages={labProps.repoPkgSel}
                                    baseImage={effectiveBaseImage}
                                />
                                <NavigationButtons ldisabled={skipImageStep} rdisabled={false} handleBack={handleBack}
                                    handleNext={handleNext} />
                            </Box>
                        )}
                        {/* Step 2: Durata laboratorio */}
                        {logicalStep === 2 && (
                            <Box style={{ width: "100%", marginTop: "50px" }}>
                                <NavigationButtons ldisabled={false} rdisabled={false} handleBack={handleBack}
                                    handleNext={handleNext} />
                                <SelectExpDate
                                    expirationDate={labProps.expirationDate}
                                    expirationMonthDuration={expirationMonthDuration}
                                    onExpDateChange={handleExpDateChange} />
                            </Box>
                        )}
                        {/* Step 3: Dimensionamento macchine */}
                        {logicalStep === 3 && (
                            <Box style={{ width: "100%", marginTop: "50px" }}>
                                <NavigationButtons ldisabled={false} rdisabled={false} handleBack={handleBack}
                                    handleNext={handleNext} />
                                <Box sx={{ width: '100%' }}>
                                    <SelectSize
                                        setBaseImage={setBaseImage}
                                        baseImage={skipImageStep ? {
                                            imageName: labProps.baseImage.name,
                                            imageSize: labProps.baseImage.size,
                                            imageSizeCustomizable: "1"
                                        } : baseImage}
                                    >
                                        <SelectProvisioningType
                                            provisioningType={provisioningType}
                                            setProvisioningType={setProvisioningType}
                                            apiAuthGroups={props.apiAuthGroups}
                                        />
                                    </SelectSize>
                                </Box>
                            </Box>
                        )}
                        {/* Step 4: Attività didattica */}
                        {logicalStep === 4 && (
                            <Box style={{ width: "100%", marginTop: "50px" }}>
                                <NavigationButtons ldisabled={false} rdisabled={false} handleBack={handleBack}
                                    handleNext={handleNext} />
                                <SelectAd
                                    apiAuthResponse={props.apiAuthResponse}
                                    apiAuthName={props.apiAuthName}
                                    apiAuthSurname={props.apiAuthSurname}
                                    apiAuthGroups={props.apiAuthGroups}
                                    setAdSelected={setAdSel}
                                    adSelected={labProps.adSel}
                                    setCoperEasy={setCoperEasy}
                                    setCoperTeacher={setCoperTeacher}
                                    labName={labProps.labName}
                                />
                                <NavigationButtons ldisabled={false} rdisabled={false} handleBack={handleBack}
                                    handleNext={handleNext} />
                            </Box>
                        )}
                        {/* Step 5: Nome Laboratorio */}
                        {logicalStep === 5 && (
                            <Box style={{ width: "100%", marginTop: "50px" }}>
                                <NavigationButtons ldisabled={false} rdisabled={!isLabNameCompleted || !isLabnameChecked} handleBack={handleBack}
                                    handleNext={handleNext} />
                                <LabName
                                    apiAuthResponse={props.apiAuthResponse}
                                    apiAuthName={props.apiAuthName}
                                    apiAuthSurname={props.apiAuthSurname}
                                    apiAuthGroups={props.apiAuthGroups}
                                    adSel={adSel}
                                    labNameSelected={setLabName}
                                    setIsLabnameChecked={setIsLabnameChecked}
                                    isLabnameChecked={isLabnameChecked}
                                    onCompletion={handleLabNameCompletion}
                                />
                            </Box>
                        )}
                        {/* Step 6: Descrizione Laboratorio */}
                        {logicalStep === 6 && (
                            <Box style={{ width: "100%", marginTop: "50px" }}>
                                <NavigationButtons ldisabled={false} rdisabled={!isLabdescriptionSpellChecked || labDescription.length === 0} handleBack={handleBack}
                                    handleNext={handleNext} />
                                <LabDescription
                                    isLabdescriptionSpellChecked={isLabdescriptionSpellChecked}
                                    setIsLabdescriptionSpellChecked={setIsLabdescriptionSpellChecked}
                                    setLabDescription={setLabDescription}
                                />
                            </Box>
                        )}
                        {/* Step 7: Note aggiuntive */}
                        {logicalStep === 7 && (
                            <Box style={{ width: "100%", marginTop: "50px" }}>
                                <label style={{ width: "85%", marginTop: "50px" }}> Note aggiuntive </label>
                                <NavigationButtons ldisabled={false} rdisabled={false} handleBack={handleBack}
                                    handleNext={handleNext} />
                                <Card sx={{ padding: 3 }}>
                                    <TextField
                                        multiline
                                        rows={3}
                                        maxLength={2000}
                                        placeholder="Inserire eventuali note aggiuntive"
                                        onChange={labNotesHandler}
                                        fullWidth
                                    />
                                </Card>
                            </Box>
                        )}
                        {/* Step 8: Modifica Docenti/Studenti o Allocazione postazioni */}
                        {logicalStep === 8 && (
                            <Box style={{ width: "100%", marginTop: "50px" }}>
                                <NavigationButtons ldisabled={false} rdisabled={false} handleBack={handleBack} handleNext={handleNext} />
                                {labProps.labType === "exam" ? (
                                    <SelectAllocationMode
                                        apiAuthResponse={props.apiAuthResponse}
                                        setStudents={setStudents}
                                        students={students}
                                        setPhysicalLabs={setPhysicalLabs}
                                        physicalLabs={labProps.physicalLabs}
                                    />
                                ) : (
                                    <StudentList
                                        status={labProps.status}
                                        isAdmin={isAdmin}
                                        apiAuthResponse={props.apiAuthResponse}
                                        isLoading={isLoading}
                                        students={labProps.students}
                                        teachers={labProps.teachers}
                                        setStudents={setStudents}
                                        setTeachers={setTeachers}
                                    />
                                )}
                                <NavigationButtons ldisabled={false} rdisabled={false} handleBack={handleBack} handleNext={handleNext} />
                            </Box>
                        )}
                        {/* Step 9: Agreement */}
                        {logicalStep === 9 && (
                            <Box style={{ width: "100%", marginTop: "50px" }}>
                                <NavigationButtons ldisabled={false} rdisabled={!isAgreementCompleted} handleBack={handleBack}
                                    handleNext={handleNext} />
                                <AgreementLab
                                    onCompletion={handleAgreementCompletion}
                                />
                            </Box>
                        )}
                        {/* Step 10: Conferma */}
                        {logicalStep === 10 && (
                            <Box style={{ width: "100%", marginTop: "50px" }}>
                                <NavigationButtons ldisabled={isSubmitted} rdisabled={true} handleBack={handleBack}
                                    handleNext={handleNext} />
                                <ReqLabConfirm
                                    isSubmitted={isSubmitted}
                                    isSubmitble={true}
                                    isSubmitting={isSubmitting}
                                    statusRequest={statusRequest}
                                    apiAuthGroups={props.apiAuthGroups}
                                    buttonDescription={"Clona laboratorio"}
                                    isAdmin={isAdmin}
                                />
                            </Box>
                        )}
                    </Container>
                </form>
            </React.Fragment>
        );


    }


    const onSubmit = async (e) => {
        e.preventDefault();

        // Lo step finale è 10 per v1 (con step immagine) o 9 per v2 (senza step immagine)
        const finalLogicalStep = 10;
        const logicalStep = activeStep + stepOffset;
        if (logicalStep !== finalLogicalStep) {
            console.log("Submit non permesso in questo step");
            return;
        }

        let formBody = [];
        let tempArraySelectedPackages = [];
        let myTeachers = [];
        let labEvents = [];
        let url;

        if (isSubmitting) return; // Evita doppio invio

        setIsSubmitting(true); // Imposta lo stato di invio
        setIsLoading(1);

        try {
            url = process.env.REACT_APP_URL_SAVE_REQ_LAB;

            tempArraySelectedPackages = installedPackages.concat(repoPkgSel);

            const currentTeacher = [{ email: props.apiAuthResponse, registrationStatus: "queued", partitions: [0] }];
            const allTeachers = [...coperTeacher, ...teachers, ...currentTeacher];
            myTeachers = Array.from(new Set(allTeachers.map(teacher => teacher.email)))
                .map(email => allTeachers.find(teacher => teacher.email === email));


            if (coperEasy.length > 0) {
                labEvents = coperEasy.map(event => ({
                    ...event,
                    scheduleType: "easy",
                    teacher: { email: props.apiAuthResponse, partition: 0 }
                }));
            } else {
                labEvents = [];
            }

            // Usa la baseImage corretta (selezionata per v1, esistente per v2)
            const effectiveBaseImage = getEffectiveBaseImage();

            const payload = (
                {
                    idLab: labProps.idLab,
                    email: props.apiAuthResponse,
                    teachers: myTeachers,
                    labName: labName,
                    labType: labProps.labType,
                    labVersion: forcedLabVersion,
                    expirationDate: expirationDate,
                    labDescription: labDescription,
                    ...(useStandardCluster ? { clusterType: 'standard' } : {}),
                    repoPkgBundleSel: repoPkgBundleSel,
                    repoPkgSel: tempArraySelectedPackages,
                    adSel: adSel,
                    labOtherActivities: labProps.labOtherActivities,
                    labNotes: labNotes,
                    baseImage: {
                        os: effectiveBaseImage.imageOs,
                        name: effectiveBaseImage.imageName,
                        des: effectiveBaseImage.imageDes,
                        size: effectiveBaseImage.imageSize,
                        feed: effectiveBaseImage.feed,
                        feedBundle: effectiveBaseImage.feedBundle,
                        imageType: effectiveBaseImage.imageType,
                        destination: effectiveBaseImage.destination,
                        hasAppVolAgent: !!effectiveBaseImage.hasAppVolAgent,
                    },
                    usageData: {
                        maxStudentsPerPartition: 0,
                        schedulerLab: labEvents,
                        provisioningType: provisioningType,
                    },
                    students: students,
                    physicalLabs: physicalLabs,
                }
            );

            formBody.push("payload=" + encodeURIComponent(JSON.stringify(payload)));

            const response = await fetch(url, {
                credentials: 'include',
                method: "POST",
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formBody
            });

            const data = await response.json();

            setIsSubmitted(1);
            setIsLoading(0);
            setStatusRequest(data.statusRequest);
        } catch (error) {
            console.log(error, "Errore!");
        } finally {
            setTimeout(() => setIsSubmitting(false), 500);
        }

    }


    if (!labProps) {
        return (
            <AppBar position="sticky" color="default" elevation={1} sx={{ backgroundColor: '#fff' }}>
                <Toolbar>
                    <IconButton edge="start" onClick={() => props.setIsShowCloneLab(false)}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#a71e3b' }}>
                        Clonazione Laboratorio Virtuale
                    </Typography>
                </Toolbar>
            </AppBar>
        );
    }

    return (
        <React.Fragment>
            <AppBar position="sticky" color="default" elevation={1} sx={{ backgroundColor: '#fff' }}>
                <Toolbar sx={{ gap: 2 }}>
                    <IconButton edge="start" onClick={() => props.setIsShowCloneLab(false)}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography variant="h6" noWrap sx={{ fontWeight: 'bold', color: '#a71e3b' }}>
                            Clonazione Laboratorio Virtuale
                        </Typography>
                        <Typography variant="body2" color="textSecondary" noWrap>
                            {labProps.labName} &mdash; {labProps.baseImage.name} ({labProps.baseImage.size})
                        </Typography>
                    </Box>
                </Toolbar>
            </AppBar>

            <Box sx={{ p: 3 }}>
                <Typography variant="body1" gutterBottom color="warning.main">
                    <strong>Attenzione:</strong> il laboratorio verrà convertito in <strong>labVersion 2</strong>.
                </Typography>
            </Box>

            {usageType()}
        </React.Fragment>
    );

}

export default LabConsolleClonePage;
